import React, { useState, useEffect } from 'react';
import Form from '../../../np-form/Form';
import {
    Button,
    Checkbox,
    Dialog,
    FormControlLabel,
    FormGroup,
    IconButton, TextField,
    Tooltip, Typography,
    withStyles
} from '@material-ui/core';
import * as formUtility from '../../../np-form/utility';
import moment from 'moment'
import {hasPermission, isSuperUser, parseURL} from '../../../sc-utilities';
import AppLogoLoading from "../../../sc-logo";
import ChangeGroupModal from "../ChangeGroupModal";
import {Info} from "@material-ui/icons";
import LicenseEditModal from "../../../sc-group/Group/LicenseEditModal";
import DisableLicensingModal from "../../../sc-group/Group/DisableLicensingModal";

const styles = theme => ({
    root: {

        padding: '6px',
        width: '91%',
        paddingLeft: '5%'
    },
    loadingScreen: {
        backgroundColor: "transparent",
        boxShadow: "none",
    },
    buttonStyle: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px'
    },
    licensing: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: "flex",
        alignItems: "center",
    },
    icon: {
        color: 'rgb(220,220,220)',
    },
    editGroupDiv: {
        display: "flex",
        alignItems: "center",
    },
    groupInput: {
        marginLeft: theme.spacing(),
    },
    assignedLicensesButton: {
        marginLeft: theme.spacing(),
    }
});

const updateFormState = props => {
    const { user, classes, translations, customer } = props;
    // First form

    const firstForm = {
        FirstName: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: translations['first_name'] || 'First name',
                label: translations['first_name'] || 'First name',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: user ? user.FirstName : '',
            validation: {
                required: true
            },
            valid: true,
            touched: false
        },
        LastName: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: translations['last_name'] || 'Last name',
                label: translations['last_name'] || 'Last name',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: user ? user.LastName : '',
            validation: {
                required: true
            },
            valid: true,
            touched: false
        },
        Username: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: translations['username'] || 'Username',
                label: translations['username'] || 'Username',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: user ? user.Username : '',
            validation: {
                required: true
            },
            valid: true,
            touched: false
        },
        Email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
                placeholder: translations['e_mail'] || 'E-Mail',
                label: translations['e_mail'] || 'E-Mail',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: user ? user.Email : '',
            validation: {
                required: true
            },
            valid: true,
            touched: false
        },
        PhoneNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: translations['phone_number'] || 'Phone number',
                className: classes && classes.inputs ? classes.inputs : null,
                label: translations['phone_number'] || 'Phone number',
                error: false,
                fullWidth: true
            },
            value: user ? user.PhoneNumber : '',
            validation: {
                required: false
            },
            valid: true,
            touched: false
        },
        Position: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: translations['user_position'] || 'Position',
                className: classes && classes.inputs ? classes.inputs : null,
                label: translations['user_position'] || 'Position',
                error: false,
                fullWidth: true
            },
            value: user ? user.Position : '',
            validation: {
                required: false
            },
            valid: true,
            touched: false
        },
        Password: {
            elementType: 'password',
            elementConfig: {
                type: 'password',
                placeholder: translations['password'] || 'Password',
                label: translations['password'] || 'Password',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: '',
            validation: {
                required: false
            },
            valid: true,
            touched: false
        },
        RepeatPassword: {
            elementType: 'password',
            elementConfig: {
                type: 'password',
                placeholder: translations['password_repeat'] || 'Password repeat ',
                label: translations['password_repeat'] || 'Password repeat ',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                error: false,
                fullWidth: true
            },
            value: '',
            validation: {
                required: false
            },
            valid: true,
            touched: false
        },
        Status: {
            elementType: 'select_v2',
            elementConfig: {
                id: "userStatus",
                fullWidth: true,
                options: [{ value: 'active', displayValue: translations['active'] || 'Active' }, { value: 'inactive', displayValue: translations['inactive'] || 'Inactive' }]
            },
            value: isSuperUser() ? user && Number(user.Status) === 1 ? 'active' : 'inactive' : user && Array.isArray(user.Customers) && user.Customers[0] && user.Customers[0].CustomerUser ? user.Customers[0].CustomerUser.Status : 'inactive',
            validation: {},
            valid: true,
            formHelperText: translations['please_select_status'] || 'Please select status'
        },
        ActiveCustomerID: {
            elementType: 'select_v2',
            elementConfig: {
                id: "userStatus",
                fullWidth: true,
                options: customer ? [...customer] : []
            },
            value: user && user.ActiveCustomerID ? user && user.ActiveCustomerID : user && user.Customers && user.Customers[0] ? user && user.Customers[0].CustomerID : null,
            validation: {},
            valid: true,
            formHelperText: translations['customer_text'] || 'Please select customer'
        },
        PasswordExpires: {
            elementType: 'checkbox',
            elementConfig: {
                type: 'checkbox',
                label: null,
                className: null,
                margin: "dense",
                fullWidth: true,
                options: [{ ID: 'checkboxID', Checked: false, Name: translations['user_to_change'] || "Force user to change password" }]
            },
            value: false,
            validation: {
                required: false
            },
            valid: true,
            touched: false
        }
    };

    return firstForm;
}

export const getUnitNameTranslation = (unit, translations) => {
    switch (unit) {
        case 'work':
            return translations["work_erasure"] || "Work Erasure";
        case 'work_verifier':
            return translations["work_erasure_verification"] || "Work Erasure Verification";
        case 'work_diagnose':
            return translations["work_diagnose"] || "Work Diagnose";
        case 'work_check':
            return translations["work_check"] || "Work Check";
        case 'mobile':
            return translations["mobile_erasure"] || "Mobile Erasure";
        case 'mobile_erasure_lite':
            return translations["mobile_erasure_lite"] || "Mobile Erasure Lite";
        case 'mobile_verifier':
            return translations["mobile_erasure_verification"] || "Mobile Erasure Verification";
        case 'mobile_diagnose':
            return translations["mobile_diagnose"] || "Mobile Diagnose";
        case 'mobile_check':
            return translations["mobile_check"] || "Mobile Check";
        case 'remote':
            return translations["remote"] || "Remote";
        case 'currency':
            return translations["money"] || "Money";
        default:
            return translations[unit?.toLowerCase()] || unit;
    }
}

export const shouldDisableEnableLicensingCheckbox = (customerLicenseSetting) => {
    return ["always_off", "always_on"].includes(customerLicenseSetting);
}

const UserEdit = props => {
    const { classes, user, activeCustomer, translations, onFetchCustomer, onFetchGroups, onFetchBulkChangeUsersGroup, onLoadUser, permissions, onEditIndividualLicenses, activeCustomerIndividualLicensingSetting } = props;
    const [customer, setCustomer] = useState([]);

    const searchParams = parseURL(window.location.search);

    const [groups, setGroups] = useState();
    const [loading, setLoading] = useState({groups: false, user: false});

    const [userForm, setUserForm] = useState(updateFormState({ ...props, customer, groups }));
    const [userFormValid, setUserFormValid] = useState(false);

    const [changeGroupModal, setChangeGroupModal] = useState({open: false, groupID: null});

    const [licenseModalState, setLicenseModalState] = useState({open: false, IndividualLicensingEnabled: !!(user?.ActiveCustomer?.IndividualLicensingEnabled) || false,  Balances: user?.Balances || []});

    const [disableLicensingModalState, setDisableLicensingModalState] = useState({open: false});

    const userFormInputChangedHandler = (event, inputIdentifier) => {
        const updateState = formUtility.getNewStateOnInputChange(event, inputIdentifier, userForm);
        setUserForm(updateState.myForm);
        if (inputIdentifier === 'Username') {
            if (
                updateState.myForm.Username.value === 'root' ||
                updateState.myForm.Username.value.includes("@") ||
                /\s+/.test(updateState.myForm.Username.value)

            ) {
                updateState.formIsValid = false;
                setUserForm({ ...updateState.myForm, Username: { ...updateState.myForm.Username, elementConfig: { ...updateState.myForm.Username.elementConfig, error: true } } })
            }
            else {
                setUserForm({ ...updateState.myForm, Username: { ...updateState.myForm.Username, elementConfig: { ...updateState.myForm.Username.elementConfig, error: false } } })
            }
        }
        if (inputIdentifier === 'Email') {
            setUserForm({ ...updateState.myForm, Email: { ...updateState.myForm.Email, elementConfig: { ...updateState.myForm.Email.elementConfig, error: !updateState.myForm.Email.valid } } })
        }

        setUserFormValid(updateState.formIsValid);
        if (inputIdentifier === 'RepeatPassword') {
            setUserForm({ ...updateState.myForm, RepeatPassword: { ...updateState.myForm.RepeatPassword, elementConfig: { ...updateState.myForm.RepeatPassword.elementConfig, error: updateState.myForm.RepeatPassword.value !== updateState.myForm.Password.value } } })
            setUserFormValid(!(updateState.myForm.RepeatPassword.value !== updateState.myForm.Password.value));
        }
        if (inputIdentifier === 'Password') {
            setUserForm({ ...updateState.myForm, RepeatPassword: { ...updateState.myForm.RepeatPassword, elementConfig: { ...updateState.myForm.RepeatPassword.elementConfig, error: updateState.myForm.RepeatPassword.value !== updateState.myForm.Password.value } } })
            setUserFormValid(!(updateState.myForm.RepeatPassword.value !== updateState.myForm.Password.value));
        }
    };
    const checkboxChangedHandler = (event, inputIdentifier) => {
        const updateState = formUtility.getNewStateOnCheckboxChange(event, inputIdentifier, userForm);
        setUserForm(updateState.myForm);
        setUserFormValid(!(updateState.myForm.RepeatPassword.value !== updateState.myForm.Password.value));
    }
    useEffect(() => {
        const fetchData = async () => {
            if (isSuperUser()) {
                let data = await onFetchCustomer({ ActiveCustomerID: activeCustomer });
                setCustomer(data)
            }
        }
        fetchData()
        return () => {

        }
    }, [activeCustomer, onFetchCustomer])
    useEffect(() => {
        setUserForm(updateFormState({ ...props, customer, groups }));
    }, [props, customer, groups])

    const submitHandler = event => {
        event.preventDefault()
        const formUser = formUtility.getFormData(userForm);
        formUser.Status = formUser.Status === 'active' ? 1 : 0;

        delete formUser["GroupID"];

        formUser.PasswordExpires = formUser.PasswordExpires ? moment().utc() : null;
        props.onEditUser({ UserDetails: { ...formUser, UserID: user.UserID }, ActiveCustomerID: activeCustomer, UserID: user.UserID });
        setUserForm(updateFormState({ translations, groups }));
        setUserFormValid(false);
    };
    if (!isSuperUser()) {
        delete userForm['ActiveCustomerID']
    }

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={loading.groups} PaperProps={{classes: {root: classes.loadingScreen}}}>
        <AppLogoLoading />
    </Dialog>

    const openChangeGroupModal = () => {
        const getGroups = async () => {
            setLoading(prevState => { return {...prevState, groups: true} });
            const result = await onFetchGroups({ActiveCustomerID: activeCustomer});
            if (result.data) {
                setGroups(result.data);
            }
            setLoading(prevState => { return {...prevState, groups: false} });
        }
        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
        setChangeGroupModal({open: true});
    }

    const handleChangeGroupCloseSafe = () => {
        setChangeGroupModal({ open: false });
    }

    const handleChangeGroupCloseDanger = async (GroupID) => {
        setChangeGroupModal({ open: false });
        await onFetchBulkChangeUsersGroup({ActiveCustomerID: activeCustomer, GroupID, UserIDs: [user?.UserID]});
        await onLoadUser({ UserID: searchParams.userID, ActiveCustomerID: activeCustomer });
    }

    useEffect(() => {
        if (user) {
            setLoading(prevState => { return {...prevState, user: false} });
        } else {
            setLoading(prevState => { return {...prevState, user: true} });
        }
    }, [user]);

    const hasAccessAllGroupsPermission = hasPermission(permissions, 'access_all_groups');

    const defaultGroupValue = user && user.UserGroups?.length>0? user.UserGroups[0]?.Group : hasAccessAllGroupsPermission? {GroupID: null, Name: translations['none'] || "None"} : null;

    const tooltip = <Typography variant="subtitle1">
        {licenseModalState?.Balances?.length>0 && licenseModalState.Balances?.map((balance) => <React.Fragment key={balance.Unit}><span>{getUnitNameTranslation(balance.Unit, translations)}: {balance.Unit==="currency"? balance.Credits : Number(balance.Credits)}</span><br/></React.Fragment>)}
    </Typography>

    const handleEnableLicensingChange = (e) => {
        const checked = e.target.checked;
        const alreadyDisabled = !checked && !user?.ActiveCustomer?.IndividualLicensingEnabled;
        const shouldOpenModal = alreadyDisabled? false : !checked;
        setDisableLicensingModalState({open: shouldOpenModal});
        setLicenseModalState(prevState => {return {...prevState, IndividualLicensingEnabled: !shouldOpenModal? checked : !!(prevState.IndividualLicensingEnabled)}});
    }

    const closeLicenseEditModal = () => {
        setLicenseModalState(prevState => {return {...prevState, open: false}});
    }

    const saveLicenseEditModal = async (Balances) => {
        setLicenseModalState({open: false});
        await onEditIndividualLicenses({UserID: searchParams?.userID, ActiveCustomerID: activeCustomer, Balances, IndividualLicensingEnabled: licenseModalState?.IndividualLicensingEnabled});
        await onLoadUser({ UserID: searchParams?.userID, ActiveCustomerID: activeCustomer });
    }

    useEffect(() => {
        setLicenseModalState({open: false, IndividualLicensingEnabled: user?.ActiveCustomer?.IndividualLicensingEnabled || false,  Balances: user?.Balances || []});
    }, [user]);

    const handleCloseDisableLicensingModal = () => {
        setDisableLicensingModalState({open: false});
    }

    const handleSaveDisableLicensingModal = async () => {
        setLicenseModalState(prevState => {return {...prevState, IndividualLicensingEnabled: false}});
        setDisableLicensingModalState({open: false});
        await onEditIndividualLicenses({UserID: searchParams?.userID, ActiveCustomerID: activeCustomer, Balances: [], IndividualLicensingEnabled: false});
        await onLoadUser({ UserID: searchParams?.userID, ActiveCustomerID: activeCustomer });
    }

    const disabledEnableLicensingCheckbox = shouldDisableEnableLicensingCheckbox(activeCustomerIndividualLicensingSetting);

    const balanceEdit = <div className={classes.licensing}>
        <FormGroup>
            <FormControlLabel
                control={
                    <Checkbox
                        id="checkbox_licensing"
                        name={"EnableLicensing"}
                        checked={!!(licenseModalState.IndividualLicensingEnabled)}
                        onChange={(e) => handleEnableLicensingChange(e)}
                        color={'primary'}
                        disabled={disabledEnableLicensingCheckbox}
                    />
                }
                label={translations["enable_individual_licensing"] || "Enable individual licensing"}
            />
            {disabledEnableLicensingCheckbox && <Typography variant="subtitle2">({translations['checkbox_licensing_setting_disabled_message'] || "Checkbox disabled due to customer setting"})</Typography>}
        </FormGroup>

        {licenseModalState.IndividualLicensingEnabled &&
        <>
            <Button variant="contained" onClick={() => setLicenseModalState(prevState => {return {...prevState, open: true}})} className={classes.assignedLicensesButton}>{translations['assigned_licenses'] || "Assigned licenses"}</Button>
            <Tooltip title={licenseModalState.Balances && Object.keys(licenseModalState.Balances).length>0? tooltip : (translations["no_licenses"] || "No licenses")}>
                <IconButton aria-haspopup="true" color="inherit">
                    <Info className={classes.icon} />
                </IconButton>
            </Tooltip>
            <LicenseEditModal user={user} modalState={licenseModalState} translations={translations} handleClose={closeLicenseEditModal} handleSave={saveLicenseEditModal} balances={licenseModalState?.Balances} currentBalances={user?.Balances || []} />
        </>}
        <DisableLicensingModal modalState={disableLicensingModalState} handleClose={handleCloseDisableLicensingModal} handleSave={handleSaveDisableLicensingModal} title={translations['disable_individual_licensing'] || 'Disable individual licensing'} translations={translations} />
    </div>

    return (
        <>
            {hasPermission(permissions, 'user_change_group') &&
            <div className={classes.editGroupDiv}>
                <Button variant="contained" onClick={openChangeGroupModal} className={classes.buttonStyle}>{translations["change_group"] || 'Change group'}</Button>
                <TextField
                    name="Group"
                    value={user && user.UserGroups?.length>0? user.UserGroups[0]?.Group?.Name : (translations['none'] || "None")}
                    placeholder={translations['current_group'] || 'Current group'}
                    label={translations['current_group'] || 'Current group'}
                    margin={"dense"}
                    className={classes.groupInput}
                    disabled={true}
                />
            </div>}

            {hasPermission(permissions, 'update_user_balance') && balanceEdit}

            <Form
                formIsValid={userFormValid}
                classes={classes}
                form={userForm}
                inputChangedHandler={userFormInputChangedHandler}
                checkboxChangedHandler={checkboxChangedHandler}
                submitHandler={submitHandler}
                buttonText={translations["save"] || 'SAVE'}
                submitButtonStyle={userFormValid ? {color: "#fafafa", borderRadius: '1px'} : {borderRadius: '1px'}}
            />
            {!loading.user && !loading.groups ?
                <ChangeGroupModal permissions={permissions} defaultValue={defaultGroupValue} modalState={changeGroupModal} handleCloseDanger={handleChangeGroupCloseDanger} handleCloseSafe={handleChangeGroupCloseSafe} translations={translations} groups={groups}/>
                : loadingScreen}
        </>
    )
}

export default withStyles(styles, { withTheme: true })(UserEdit);




